export const translations = {
  configuracoes: {
    pt: 'Configurações',
    en: 'Settings',
    de: 'Einstellungen',
    es: 'Configuración',
  },
  novoUsuario: {
    pt: 'Novo usuário',
    en: 'New user',
    de: 'Neuer Benutzer',
    es: 'Nuevo usuario',
  },
  reportFileName: {
    pt: 'RELATÓRIO-USUÁRIOS-BAYER.xlsx',
    en: 'BAYER-USERS-REPORT.xlsx',
    de: 'BAYER-BENUTZER-BERICHT.xlsx',
    es: 'INFORME-USUARIOS-BAYER.xlsx',
  },
  exportar : {
    pt: 'Exportar',
    en: 'Export',
    de: 'Exportieren',
    es: 'Exportar',
  },
};
